var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRating1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fd575f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cf1d26"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: 1,
    y2: 0,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9176",
    "data-name": "Group 9176",
    transform: "translate(-3249 -10364)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_439",
    "data-name": "Ellipse 439",
    cx: 37,
    cy: 37,
    r: 37,
    transform: "translate(3249 10364)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_444",
    "data-name": "Ellipse 444",
    cx: 34,
    cy: 34,
    r: 34,
    transform: "translate(3252 10367)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9171",
    "data-name": "Group 9171",
    transform: "translate(3266.449 10390.018)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8882",
    "data-name": "Path 8882",
    d: "M.689,0A.655.655,0,0,0,.49,1.29,10.853,10.853,0,0,1,5.381,4.078a5.543,5.543,0,1,0,8.672,4.574C14.053,1.239,3.514.158.689,0",
    transform: "translate(0 0)",
    fill: "#581818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8883",
    "data-name": "Path 8883",
    d: "M155.716,0c-2.824.157-13.364,1.237-13.364,8.651a5.543,5.543,0,1,0,8.672-4.574,10.854,10.854,0,0,1,4.891-2.788.655.655,0,0,0-.2-1.288",
    transform: "translate(-116.232 0)",
    fill: "#581818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8884",
    "data-name": "Path 8884",
    d: "M69.606,125.992a1.565,1.565,0,0,1-1.326-.731,10.138,10.138,0,0,0-8.211-4.355,10.435,10.435,0,0,0-8.228,4.381,1.566,1.566,0,0,1-2.619-1.718,13.624,13.624,0,0,1,10.847-5.8A13.312,13.312,0,0,1,70.933,123.6a1.567,1.567,0,0,1-1.327,2.4",
    transform: "translate(-39.982 -96.163)",
    fill: "#581818"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating1);
export default __webpack_public_path__ + "static/media/rating_1.4fb3c6732f171c2760aa2a028afae30e.svg";
export { ForwardRef as ReactComponent };